import { BaseFieldModel, IBaseFieldModel } from '../base/blueprint-field-base.model';

export interface IFormattedTextModel extends IBaseFieldModel {
  isRequired: boolean;
  isReadOnly: boolean;
  maskExpression: string;
}
export class FormattedTextModel extends BaseFieldModel implements IFormattedTextModel {
  constructor(
    public isRequired: boolean,
    public isReadOnly: boolean,
    public maskExpression: string,
  ) {
    super(isRequired, isReadOnly);
  }
}
